module.exports = __webpack_public_path__ + "media/images/icons/outlined/expand-dfd0b582b408bd3681042eb691072e95.svg";